import {Button} from '@wandb/weave/components';
import * as React from 'react';
import {RunWithRunsetInfo} from 'src/state/runs/types';

import {Sort} from '../../../util/queryTypes';
import {useResetColors} from './useResetColors';

export const ResetRunColors = ({
  sort,
  rows,
}: {
  sort: Sort;
  rows: RunWithRunsetInfo[];
}) => {
  const resetRunColorsConfig = useResetColors({sort, rows});
  return (
    <div>
      <div className="mb-8">
        <Button
          disabled={
            rows.length < 2 ||
            (!resetRunColorsConfig.modifiedSort &&
              !resetRunColorsConfig.hasActiveFilter &&
              !resetRunColorsConfig.hasActiveSearch &&
              !resetRunColorsConfig.hasActiveGroupKeys)
          }
          onClick={resetRunColorsConfig.randomizeColors}>
          Randomize colors
        </Button>
      </div>
      <div>
        <Button
          disabled={!resetRunColorsConfig.hasCustomRunColors}
          variant="ghost"
          onClick={resetRunColorsConfig.resetColors}>
          Reset colors
        </Button>
      </div>
    </div>
  );
};
